import WallPyramid from "../pyramids/WallPyramid.jsx";
import TrianglePyramid from "../pyramids/TrianglePyramid.jsx";
import TowerPyramid from "../pyramids/TowerPyramid.jsx";
import FloorBlock from "../race/block/FloorBlock.jsx";
import Race from "../race/Race.jsx";
import Tree from "../trees/Tree.jsx";
import MiniTreeGreen from "../trees/MiniTreeGreen.jsx";
import MiniTreeOrange from "../trees/MiniTreeOrange.jsx";
import TreeOrange from "../trees/TreeOrange.jsx";
import TreeYellow from "../trees/TreeYellow.jsx";
import MiniTreeYellow from "../trees/MiniTreeYellow.jsx";
import MiniTreeRed from "../trees/MiniTreeRed.jsx";
import TreeRed from "../trees/TreeRed.jsx";

const GameZone = ({ position = [0, 0, 0] }) => {
  return (
    <group position={position}>
      <Tree position={[-10.5, 0, 10.5]} rotation={[0, Math.PI / 2, 0]} />
      <MiniTreeGreen position={[-13.5, 0, -5.5]} rotation={[0, 0, 0]} />
      <MiniTreeGreen position={[-7.5, 0, -11.5]} rotation={[0, 0, 0]} />
      <MiniTreeOrange position={[-7.5, 0, -25.5]} rotation={[0, 0, 0]} />
      <MiniTreeOrange position={[10.5, 0, -25.5]} rotation={[0, 0, 0]} />
      <TreeOrange position={[1.5, 0, -25.5]} rotation={[0, Math.PI / 2, 0]} />
      <MiniTreeGreen position={[10.5, 0, -11.5]} rotation={[0, 0, 0]} />
      <MiniTreeYellow position={[-20.5, 0, -19.5]} rotation={[0, 0, 0]} />
      <MiniTreeYellow position={[-26.5, 0, -12.5]} rotation={[0, 0, 0]} />
      <TreeYellow position={[-26.5, 0, 2.5]} rotation={[0, 0, 0]} />
      <MiniTreeYellow position={[-26.5, 0, 17.5]} rotation={[0, 0, 0]} />
      <MiniTreeRed position={[-19.5, 0, 25.5]} rotation={[0, 0, 0]} />
      <TreeRed position={[-11, 0, 25.5]} rotation={[0, 0, 0]} />
      <MiniTreeRed position={[-2.5, 0, 25.5]} rotation={[0, 0, 0]} />
      <FloorBlock position={[26.5, 0, -2.5]} scale={0.7} />
      <FloorBlock position={[23.5, 0, -0.5]} scale={0.7} />
      <Race position={[16.5, -0.99, -12.5]} />
      <WallPyramid position={[2.5, 0, -0.5]} rotation={[0, Math.PI / 2, 0]} />
      <TrianglePyramid
        position={[-3.5, 0, -0.5]}
        rotation={[0, Math.PI / 2, 0]}
      />
      <TowerPyramid position={[-9.5, 0, -0.5]} rotation={[0, Math.PI / 2, 0]} />
    </group>
  );
};

export default GameZone;
